// extracted by mini-css-extract-plugin
export default {"label":"Label--label---7XdR"};